import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { FaHome, FaSchool, FaPlus } from 'react-icons/fa';
import SuperDashboard from './Dashboard';
import Schools        from './Schools';
import RegisterSchool from './RegisterSchool';

const navItems = [
  { type: 'section', label: 'Platform' },
  { to: '/super-admin',          label: 'Dashboard',       icon: FaHome },
  { to: '/super-admin/schools',  label: 'Schools',         icon: FaSchool },
  { to: '/super-admin/register', label: 'Register School', icon: FaPlus },
];

export default function SuperAdminApp() {
  return (
    <DashboardLayout sidebarItems={navItems} title="Super Admin">
      <Routes>
        <Route index           element={<SuperDashboard />} />
        <Route path="schools"  element={<Schools />} />
        <Route path="register" element={<RegisterSchool />} />
        <Route path="*"        element={<Navigate to="/super-admin" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
